import { render, staticRenderFns } from "./Inspect.vue?vue&type=template&id=50f35562&scoped=true&"
import script from "./Inspect.vue?vue&type=script&lang=js&"
export * from "./Inspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f35562",
  null
  
)

export default component.exports